import React from 'react';
export function PainSection() {
  return <section className="bg-[#F5F5F5] py-3 md:py-4 px-3 border-b border-gray-200" data-id="element-89">
      <div className="max-w-2xl mx-auto" data-id="element-90">
        <div className="text-center mb-2" data-id="element-91">
          
        </div>

        <h2 className="text-xl md:text-2xl font-black text-[#0B1F3A] mb-2 text-center leading-tight" data-id="element-92">
          Si das clases de entrenamiento funcional… esto te pasa.
        </h2>

        <div className="bg-white border-2 border-gray-200 rounded-xl p-3 md:p-4 shadow-lg" data-id="element-93">
          <p className="text-sm md:text-base text-gray-700 font-medium mb-2 leading-relaxed text-center" data-id="element-94">
            Terminás una clase… y ya tenés que pensar la siguiente. Buscás
            ejercicios. Pensás qué circuito armar. Intentás organizar todo… pero
            nunca termina de cerrar.
          </p>

          <div className="bg-red-50 border-l-4 border-red-500 p-2 mb-3" data-id="element-95">
            <p className="text-base md:text-lg font-black text-red-600 text-center" data-id="element-96">
              Y al final… 👉 Terminás improvisando.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-1.5 mb-3" data-id="element-97">
            {['No tenés una estructura clara', 'Repetís ejercicios', 'Perdés horas todas las semanas', 'No sabés si tus alumnos progresan'].map((item, i) => <div key={i} className="flex items-center gap-1.5 bg-[#F5F5F5] p-2 rounded-lg border border-gray-200" data-id="element-98">
                <span className="text-red-500 text-sm flex-shrink-0" data-id="element-99">❌</span>
                <span className="text-gray-800 font-bold text-xs md:text-sm" data-id="element-100">
                  {item}
                </span>
              </div>)}
          </div>

          <p className="text-sm text-gray-700 font-medium mb-2 text-center" data-id="element-101">
            Y eso no solo te consume tiempo…
          </p>

          <div className="bg-[#0B1F3A] rounded-lg p-2.5 text-center mb-2" data-id="element-102">
            <p className="text-[#FF6B00] font-black text-sm md:text-base" data-id="element-103">
              👉 Te hace dar clases por debajo de tu nivel.
            </p>
          </div>

          <p className="text-lg md:text-xl font-black text-[#0B1F3A] text-center" data-id="element-104">
            ¿Cuántas clases más vas a seguir improvisando?
          </p>
        </div>
      </div>
    </section>;
}